const customColorPickerStyle = () => ({
	container: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		width: '192px',
		margin: '8px auto',
	},
	tileWrapper: {
		width: '32px',
		maxWidth: '32px',
		height: '32px',
		flexBasis: '15%',
		flexGrow: 1,
		padding: '4px',
		transition: 'padding .1s ease-in-out',
		position: 'relative',
	},
	tile: {
		width: '100%',
		height: '100%',
		borderRadius: '4px',
		cursor: 'pointer',
	},
	active: {
		padding: '1px',
	},
	icon: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		color: 'white',
	},
});

export default customColorPickerStyle;
